import parse from 'html-react-parser';
import { isEmpty } from 'lodash';
import { FC, Fragment } from 'react';
import { IntlShape } from 'react-intl';
import { useDispatch } from 'react-redux';

import { ProductInfoModel } from '../../../../models/request.model';
import { togglePopup } from '../../../../store/ui';

import { useMedia } from '../../../context/InterfaceContext';
import Divider from '../../shared/Divider';
import { Cell, Row, Table } from '../../shared/table';

const TechnicalInformation: FC<{
    data: {
        data: Array<{ href: string; label: string; value: string }>;
        productionlink: string | null;
    } | null;
    dataForModal: ProductInfoModel[];
    intl: IntlShape;
    productFormatCode: string;
}> = ({ data, dataForModal, intl, productFormatCode }) => {
    const { isMobileOrTablet } = useMedia();
    const dispatch = useDispatch();
    const alternativeTitleCodes = ['PRO', 'SAM', 'FRA'];
    const isAlternativeText = alternativeTitleCodes.includes(productFormatCode);

    if (!!data && !isEmpty(data.data)) {
        return (
            <section className="product-page__tech-info-wrapper">
                <h3>{intl.formatMessage({ id: 'product.techInfoTitle', defaultMessage: 'Technische Informationen' })}</h3>

                <div>
                    <Table w={isMobileOrTablet ? 500 : 820}>
                        {data.data.map(({ href, label, value }) => (
                            <Fragment key={`fg-${label}-${value}`}>
                                <Row styles={{ height: '100%', minHeight: isMobileOrTablet ? 50 : 64 }}>
                                    <Cell styles={{ paddingLeft: isMobileOrTablet ? 20 : 30 }} fw={700}>
                                        {label}
                                    </Cell>

                                    <Cell styles={{ padding: `10px ${isMobileOrTablet ? 20 : 30}px` }} h={'100%'}>
                                        {href ? (
                                            <a className="red-text text-decoration-none cursor-pointer" href={href}>
                                                {value}
                                            </a>
                                        ) : value.startsWith('<a href=') ? (
                                            <div className="link-container">{parse(value)}</div>
                                        ) : (
                                            value
                                        )}
                                    </Cell>
                                </Row>

                                <Divider size={2} margin={0} />
                            </Fragment>
                        ))}

                        {data.productionlink && (
                            <Row>
                                <Cell styles={{ paddingLeft: isMobileOrTablet ? 20 : 30 }} fw={700}>
                                    {isAlternativeText
                                        ? intl.formatMessage({
                                              id: 'product.advertisingMaterialSpecification',
                                              defaultMessage: 'Spezifikation',
                                          })
                                        : intl.formatMessage({
                                              id: 'product.advertisingMaterial',
                                              defaultMessage: 'Werbemittelproduktion',
                                          })}
                                </Cell>

                                <Cell styles={{ padding: `10px ${isMobileOrTablet ? 20 : 30}px` }} fw={500}>
                                    {data.productionlink === '#REQUEST#' ? (
                                        <a
                                            className="red-text text-decoration-none cursor-pointer"
                                            style={{ fontSize: 'inherit' }}
                                            onClick={() =>
                                                dispatch(
                                                    togglePopup({
                                                        name: 'location_request',
                                                        status: true,
                                                        payload: dataForModal,
                                                    })
                                                )
                                            }
                                        >
                                            {intl.formatMessage({
                                                id: 'product.viewDetailsTrafficOutside',
                                                defaultMessage: 'Auf Anfrage',
                                            })}
                                        </a>
                                    ) : (
                                        <a
                                            href={data.productionlink}
                                            className="red-text text-decoration-none"
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ fontSize: 'inherit' }}
                                        >
                                            {intl.formatMessage({
                                                id: 'product.viewDetails',
                                                defaultMessage: 'Details anzeigen',
                                            })}
                                        </a>
                                    )}
                                </Cell>
                            </Row>
                        )}
                    </Table>
                </div>
            </section>
        );
    }

    return null;
};

export default TechnicalInformation;
